<script>
// Generated with AI

export default {
  props: {
    email: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      resending: false,
      resent: false,
      blocked: false,
      showSpamNote: false,
    }
  },

  methods: {
    async onResend() {
      this.resending = true
      try {
        const response = await fetch("/register/resend", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "",
          },
          body: JSON.stringify({ email: this.email }),
        })
        const data = await response.json()

        if (data.success) {
          this.resent = true
          if (data.spam_note) {
            this.showSpamNote = true
          }
        } else if (data.blocked) {
          this.blocked = true
        }
      } catch {
        // Silently fail — the user can try again
      } finally {
        this.resending = false
      }
    },
  },
}
</script>

<template>
  <div class="text-center py-5">
    <h3>Check Your Email</h3>
    <p class="mt-3">We sent a confirmation email to <strong>{{ email }}</strong>.</p>
    <p>Click the link in the email to complete your registration.</p>

    <div v-if="!blocked" class="mt-4">
      <p v-if="resent" class="text-success">Email resent!</p>
      <p v-if="showSpamNote" class="text-muted">
        <strong>Tip:</strong> Check your spam or junk folder if you don't see it.
      </p>
      <button
        class="btn btn-link"
        :disabled="resending"
        @click.prevent="onResend"
      >
        {{ resending ? "Sending..." : "Didn't get the email? Resend" }}
      </button>
    </div>

    <div v-if="blocked" class="alert alert-warning mt-4">
      Unable to send another confirmation. Please contact
      <a href="mailto:support@lyrics2learn.com">support@lyrics2learn.com</a>.
    </div>
  </div>
</template>
